import ClipboardIcon from "@assets/svg/ClipboardIcon";
import MonitorIcon from "@assets/svg/MonitorIcon";
import StackIcon from "@assets/svg/StackIcon";
import UsersIcon from "@assets/svg/UsersIcon";
import { RootState } from "@store/reducers";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import RecentActivity from "./components/RecentActivity";
import InterviewMeetingsSection from "./components/InterviewMeetingsSection";
import { SwitchCameraIcon } from "lucide-react";
import SwitchIcon from "@assets/svg/SwitchIcon";
import SwitchAccountSection from "./components/SwitchAccountSection";
import { EnumUserTypes } from "@utils/constants";
import HandshakeIcon from "@assets/svg/HandshakeIcon";
import ReceiptIcon from "@assets/svg/ReceiptIcon";
import CreditCardIcon from "@assets/svg/CreditCardIcon";
import { useEffect, useState } from "react";
import ReferralPartnerPopup from "@components/ReferralPartnerPopup/ReferralPartnerPopup";

const candidateStats = [
  {
    label: "Applied Jobs",
    value: 0,
    icon: <StackIcon className="w-8 h-8" />,
  },
  {
    label: "Interviews",
    value: 0,
    icon: <MonitorIcon className="w-8 h-8" />,
  },
  {
    label: "Saved Jobs",
    value: 0,
    icon: <ClipboardIcon className="w-8 h-8" />,
  },
  {
    label: "Profile Views",
    value: 0,
    icon: <UsersIcon className="w-8 h-8" />,
  },
];

const referralStats = [
  {
    label: "Payments received",
    value: '£120,000',
    icon: <StackIcon className="w-8 h-8" />,
  },
  {
    label: "Pending payments",
    value: '£30,000',
    icon: <CreditCardIcon className="w-8 h-8" />,
  },
  {
    label: "Future payments",
    value: '£50,000',
    icon: <ReceiptIcon className="w-8 h-8" />,
  },
  {
    label: "Candidates placed",
    value: 150,
    icon: <HandshakeIcon className="w-8 h-8" />,
  },
];

const DashboardPage = () => {
  const user = useSelector((state: RootState) => state.auth.user);
  const [isReferralPartnerPopupOpen, setIsReferralPartnerPopupOpen] =
    useState(false);

  useEffect(() => {
    if (user?.userType !== EnumUserTypes.CANDIDATE || !user?._id) {
      return;
    }

    const pendingPopup = localStorage.getItem("referralPartnerPopupPending");
    const pendingUserId = localStorage.getItem(
      "referralPartnerPopupPendingUserId"
    );
    if (pendingPopup === "1" || pendingUserId === String(user._id)) {
      setIsReferralPartnerPopupOpen(true);
      localStorage.removeItem("referralPartnerPopupPendingUserId");
      localStorage.removeItem("referralPartnerPopupPending");
    }
  }, [user?._id, user?.userType]);

  return (
    <div className="flex flex-col flex-1 rounded-md bg-white p-8">
      <ReferralPartnerPopup
        open={isReferralPartnerPopupOpen}
        onClose={() => setIsReferralPartnerPopupOpen(false)}
      />
      <div className="flex flex-col gap-1">
        <span className="font-bold text-2xl text-primary">
          Welcome back, {user?.firstName} {user?.lastName}!
        </span>
        <span className="text-xs text-light-black font-medium">
          Here’s a quick overview of your job activity.
        </span>
      </div>

      {/* Row 1 */}
      <div className="flex mt-7 gap-8">
        {/* Col 1 */}
        <div className="grid grid-cols-2 w-[55%] rounded-md gap-3">
          {(user?.userType === EnumUserTypes.CANDIDATE
            ? candidateStats
            : referralStats
          )?.map((stat) => {
            return (
              <div className="flex gap-3 w-full rounded-md bg-light-white-700 py-5 pl-5">
                <div className="flex items-center justify-center w-14 h-14 rounded-md bg-white">
                  {stat?.icon}
                </div>
                <div className="flex flex-col justify-between py-1">
                  <span className="font-medium text-sm text-primary">
                    {stat?.label}
                  </span>
                  <span className="font-bold text-lg">{stat?.value}</span>
                </div>
              </div>
            );
          })}
        </div>
        {/* Col 2 */}
        <div className="w-[45%] rounded-md bg-light-white-700 p-3 gap-3 flex flex-col">
          <SwitchAccountSection />
        </div>
      </div>

      {/* Row 2 */}
      <div className="flex mt-10 gap-8 min-h-0">
        {/* Recent Activity */}
        <RecentActivity />
        {/* Interviews/Meetings */}
        <InterviewMeetingsSection />
      </div>
    </div>
  );
};

export default DashboardPage;
